import { SUPPORTED_CURRENCIES } from '../types'

export function formatCurrency(amount: number, currencyCode: string): string {
  const found = SUPPORTED_CURRENCIES.find((c) => c.code === currencyCode)
  const symbol = found?.symbol ?? currencyCode

  const isNegative = amount < 0
  const formatted = new Intl.NumberFormat('en-NG', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(amount))

  return `${isNegative ? '-' : ''}${symbol}${formatted}`
}

export function parseCurrency(str: string): number {
  const cleaned = str.replace(/[^0-9.-]/g, '')
  return parseFloat(cleaned) || 0
}
